import { createContext, useCallback, useContext, useState } from "react";

const DraftPostContext = createContext(null);

export const DraftPostProvider = ({ children }) => {
  const [file, setFile] = useState(null);
  const [files, setFiles] = useState([]);
  const [contentType, setContentType] = useState("note");
  const [dt, setDt] = useState(null);
  const [meta, setMeta] = useState({});

  const resetDraft = useCallback(() => {
    setFile(null);
    setFiles([]);
    setContentType("note");
    setDt(null);
    setMeta({});
  }, []);

  return (
    <DraftPostContext.Provider
      value={{
        file,
        setFile,
        files,
        setFiles,
        contentType,
        setContentType,
        dt,
        setDt,
        meta,
        setMeta,
        resetDraft,
      }}
    >
      {children}
    </DraftPostContext.Provider>
  );
};

export const useDraftPost = () => {
  const ctx = useContext(DraftPostContext);
  if (!ctx) {
    throw new Error("useDraftPost must be used within a DraftPostProvider");
  }
  return ctx;
};
